import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=379ff9c4&"
import script from "./AlertBanner.vue?vue&type=script&lang=ts&"
export * from "./AlertBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports